
import endPoints from '../../../config/endPoints';

const THANKYOU_CONSTANTS = Object.freeze({
  SOCIAL_MEDIA: [
    {
      keyIndex: 0,
      href: endPoints.ZAGGLE_FB,
      className: 'fa fa-facebook-f',
    },
    {
      keyIndex: 1,
      href: endPoints.ZAGGLE_TWITTER,
      className: 'fa fa-twitter',
    },
    {
      keyIndex: 2,
      href: endPoints.ZAGGLE_INSTAGRAM,
      className: 'fa fa-instagram',
    },
    {
      keyIndex: 3,
      href: endPoints.ZAGGLE_LINKEDIN,
      className: 'fa fa-linkedin',
    },
    {
      keyIndex: 4,
      href: endPoints.ZAGGLE_YOUTUBE,
      className: 'fa fa-youtube',
    },
  ],
});

export default THANKYOU_CONSTANTS;



// WEBPACK FOOTER //
// client/containers/StaticPages/Thankyou/constants.js